import $ from 'jquery'

$(document).ready(function() {
    $('.contact-us-right').css({'max-height': $(window).height()})
})